import { createSelector } from 'reselect'

// PLOP_APPEND_PATTERN_ANCHOR
// Get sroi reports
export const getSroiReportsSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.getSroiReports.results,
  results => results
)

export const getSroiReportsIsLoadingSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.getSroiReports.isLoading,
  isLoading => isLoading
)

export const getSroiReportsErrorSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.getSroiReports.error,
  error => error
)

export const getSroiReportsWasLoadedSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.getSroiReports.wasLoaded,
  wasLoaded => wasLoaded
)

// Get social return on investment report
export const socialReturnOnInvestmentReportSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.socialReturnOnInvestmentReport.data,
  data => data
)

export const getSocialReturnOnInvestmentReportIsLoadingSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.socialReturnOnInvestmentReport.isLoading,
  isLoading => isLoading
)

export const getSocialReturnOnInvestmentReportErrorSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.socialReturnOnInvestmentReport.error,
  error => error
)

export const socialReturnOnInvestmentReportWasLoadedSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.socialReturnOnInvestmentReport.wasLoaded,
  wasLoaded => wasLoaded
)

// Get sroi report
export const sroiReportPayloadSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.sroiReportPayload.data,
  data => data
)

export const getSroiReportPayloadIsLoadingSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.sroiReportPayload.isLoading,
  isLoading => isLoading
)

export const getSroiReportPayloadErrorSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.sroiReportPayload.error,
  error => error
)

export const sroiReportPayloadWasLoadedSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.sroiReportPayload.wasLoaded,
  wasLoaded => wasLoaded
)

// Create sroi report payload
export const createSroiReportPayloadSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.createSroiReportPayload.data,
  data => data
)

export const createSroiReportPayloadIsLoadingSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.createSroiReportPayload.isLoading,
  isLoading => isLoading
)

export const createSroiReportPayloadErrorSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.createSroiReportPayload.error,
  error => error
)

export const createSroiReportPayloadWasCreatedSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.createSroiReportPayload.wasCreated,
  wasCreated => wasCreated
)

// Update sroi report
export const updateSroiReportPayloadSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.updateSroiReportPayload.data,
  data => data
)

export const updateSroiReportPayloadIsLoadingSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.updateSroiReportPayload.isLoading,
  isLoading => isLoading
)

export const updateSroiReportPayloadErrorSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.updateSroiReportPayload.error,
  error => error
)

export const updateSroiReportPayloadWasUpdatedSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.updateSroiReportPayload.wasUpdated,
  wasUpdated => wasUpdated
)

// Delete sroi report payload
export const deleteSroiReportPayloadSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.deleteSroiReportPayload,
  deleteSroiReportPayload => deleteSroiReportPayload
)

export const deleteSroiReportPayloadIsLoadingSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.deleteSroiReportPayload.isLoading,
  isLoading => isLoading
)

export const deleteSroiReportPayloadErrorSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.deleteSroiReportPayload.error,
  error => error
)

export const deleteSroiReportPayloadWasDeletedSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.deleteSroiReportPayload.wasDeleted,
  wasDeleted => wasDeleted
)

// Get sroi inputs preset
export const getSroiInputsPresetSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.getSroiInputsPreset.data,
  data => data
)

export const getSroiInputsPresetIsLoadingSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.getSroiInputsPreset.isLoading,
  isLoading => isLoading
)

export const getSroiInputsPresetErrorSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.getSroiInputsPreset.error,
  error => error
)

export const getSroiInputsPresetWasLoadedSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.getSroiInputsPreset.wasLoaded,
  wasLoaded => wasLoaded
)

// Update sroi inputs preset
export const updateSroiInputsPresetSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.updateSroiInputsPreset.data,
  data => data
)

export const updateSroiInputsPresetIsLoadingSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.updateSroiInputsPreset.isLoading,
  isLoading => isLoading
)

export const updateSroiInputsPresetErrorSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.updateSroiInputsPreset.error,
  error => error
)

export const updateSroiInputsPresetWasUpdatedSelector = createSelector(
  ({ socialReturnOnInvestment }) => socialReturnOnInvestment.updateSroiInputsPreset.wasUpdated,
  wasUpdated => wasUpdated
)
